import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IField } from '@shared/model/basic-data';

@Injectable({
  providedIn: 'root',
})
export class AdditionalDataService {
  private _baseUrl: string = `${environment.apiUrl}/projects/additional_project_information`;

  constructor(private _http: HttpClient) {}

  getAdditionalData(id: number): Observable<any> {
    return this._http.get(`${this._baseUrl}/${id}/`);
  }

  updateAdditionalData(id: number, data: IField): Observable<any> {
    return this._http.patch(`${this._baseUrl}/${id}/`, {
      [data.name]: data.value,
    });
  }
}
